import { render, staticRenderFns } from "./officialAccount6.vue?vue&type=template&id=96b29892&scoped=true"
import script from "./officialAccount6.vue?vue&type=script&lang=js"
export * from "./officialAccount6.vue?vue&type=script&lang=js"
import style0 from "./officialAccount6.vue?vue&type=style&index=0&id=96b29892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b29892",
  null
  
)

export default component.exports